import { Campaign } from '../types/campaign';
import { parseContent, parseContents } from '../utils';
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { getProjectErrorFromRawError, isProjectError } from '../../utils/errors';
import { CreateCampaignDto, UpdateCampaignDto } from '../typeDtos/campaign';
import { ProjectErrorType } from '../../utils/errors/types';
import { parseCampaign, parseCampaigns } from './parser';
import { executeCloudFunction } from '../index';

export const getAllCampaigns = async (): Promise<Campaign[]> => {
  try {
    const _query = query(collection(db, 'deepLinks'), where('type', '==', 'campaign'));
    const rawResult = await getDocs(_query);
    return await parseCampaigns(parseContents(rawResult));
  } catch (error) {
    console.log('[CAMPAIGNS] Error at getAllCampaigns:', error);
    return [];
  }
};

export const createCampaign = async (data: CreateCampaignDto): Promise<ProjectErrorType | Campaign> => {
  try {
    const result = await executeCloudFunction('createCampaign', { campaign: data });
    if (isProjectError(result)) {
      return getProjectErrorFromRawError(result as Error);
    }
    return result as Campaign;
  } catch (e) {
    console.log('[CAMPAIGNS] Error at createCampaign:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};

export const updateCampaign = async (data: Partial<UpdateCampaignDto>): Promise<ProjectErrorType | Campaign> => {
  try {
    const result = await executeCloudFunction('updateCampaign', { campaign: data });
    if (isProjectError(result)) {
      return getProjectErrorFromRawError(result as Error);
    }
    return result as Campaign;
  } catch (e) {
    console.log('[CAMPAIGNS] Error at updateCampaign:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};

export const deleteCampaign = async (id: string): Promise<ProjectErrorType | { success: boolean }> => {
  try {
    const result = await executeCloudFunction('deleteCampaign', { id });
    if (isProjectError(result)) {
      return getProjectErrorFromRawError(result as Error);
    }
    return { success: true };
  } catch (e) {
    console.log('[CAMPAIGNS] Error at deleteCampaign:', e);
    return getProjectErrorFromRawError(e as Error);
  }
};
